const Experience = () => {
    return (
        <div>
            Work experience
        </div>
    )
};

export default Experience;